const API_URL = "https://api.destinationautourdumonde.fr"

export default API_URL